import React from "react";
import { Inbox } from "lucide-react";

interface EmptyStateProps {
  /** Dòng chữ chính. Mặc định: "Chưa có dữ liệu". */
  message?: string;
  /** Mô tả phụ (tuỳ chọn). */
  description?: string;
  /** Icon thay thế (mặc định: Inbox của lucide). */
  icon?: React.ReactNode;
  className?: string;
}

/**
 * Trạng thái rỗng dùng CHUNG cho mọi bảng / danh sách.
 * Dùng icon (lucide) thay emoji để đồng nhất giao diện.
 */
const EmptyState: React.FC<EmptyStateProps> = ({
  message = "Chưa có dữ liệu",
  description,
  icon,
  className = "",
}) => (
  <div className={`flex flex-col items-center justify-center py-16 text-gray-400 ${className}`}>
    <span className="mb-3 grid h-14 w-14 place-items-center rounded-full bg-gray-100 text-gray-400">
      {icon ?? <Inbox className="h-7 w-7" strokeWidth={1.5} />}
    </span>
    <span className="text-sm font-medium text-gray-500">{message}</span>
    {description && <span className="mt-1 text-xs text-gray-400">{description}</span>}
  </div>
);

export default EmptyState;
